// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"_7a3fb80146--tooltip--Ymqut"};